import React from 'react'
import PropTypes from 'prop-types'

// Components
import InputGroup from 'react-bootstrap/InputGroup'
import FormControl from 'react-bootstrap/FormControl'

// Css
import './Search.scss'

export const Search = ({
  placeholder,
  value,
  onChange,
  onSearch,
  ...props
}) => {
  const onKeyUp = (e) => {
    if (e.keyCode === 13) {
      onSearch()
    }
  }

  const onSearchChange = (e) => {
    onChange(e.target.value)
  }

  return (
    <InputGroup className="x-search" {...props}>
      <FormControl
        placeholder={placeholder}
        className="input"
        value={value}
        onKeyUp={onKeyUp}
        onChange={onSearchChange}
      />
      <InputGroup.Append>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          viewBox="0 0 24.775 24.771"
          onClick={() => onSearch()}
        >
          <g transform="translate(-1.999 -2.12)">
            <path
              d="M16.65,2.12h-.125A10.514,10.514,0,0,0,8.179,19.064l-5.8,5.677a1.254,1.254,0,0,0,1.755,1.792l5.8-5.677a10.477,10.477,0,0,0,6.479,2.331h.125A10.54,10.54,0,0,0,16.65,2.12Zm-.213,18.56a8.033,8.033,0,1,1,8.121-7.933,8.033,8.033,0,0,1-8.121,7.933Z"
              transform="translate(0 0)"
            />
          </g>
        </svg>
      </InputGroup.Append>
    </InputGroup>
  )
}

Search.propTypes = {
  value: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  onSearch: PropTypes.func,
}

Search.defaultProps = {
  value: '',
  placeholder: 'Type search here',
  onChange: () => {},
  onSearch: () => {},
}

export default Search
